export function timeToMinutes(timeString) {
  // Split the time string into hours, minutes, seconds, and milliseconds
  const [hours, minutes, seconds] = timeString.split(':').map(parseFloat);

  // Calculate the total minutes
  const totalMinutes = hours * 60 + minutes + seconds / 60;

  return totalMinutes;
}

export const getUniqueId = function () {
  let uniqueId = localStorage.getItem('user_unique_id');

  if (!uniqueId) {
    uniqueId = Date.now().toString(36) + Math.random().toString(36).substr(2);
    localStorage.setItem('user_unique_id', uniqueId);
  }

  return uniqueId;
};
